import type { CSSProperties } from 'react';

const fontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';

const textStyle = (
  fontSize: number,
  fontWeight: 400 | 500 | 600,
  lineHeight: number
): CSSProperties => ({
  fontFamily,
  fontSize: `${fontSize / 16}rem`,
  fontWeight,
  lineHeight: `${lineHeight}px`,
  letterSpacing: 0
});

export const typography = {
  headingXxLarge: textStyle(48, 600, 56),
  headingXLarge: textStyle(32, 600, 40),
  headingLarge: textStyle(24, 600, 32),
  headingMedium: textStyle(18, 500, 24),
  bodyLarge: textStyle(16, 400, 24),
  bodyMedium: textStyle(14, 400, 20),
  bodySmall: textStyle(12, 400, 16),
  bodyXSmall: textStyle(10, 400, 14)
};

export type DesignSystemTypographyVariant = keyof typeof typography;

export const figmaTextStyles: Record<DesignSystemTypographyVariant, string> = {
  headingXxLarge: 'Heading/XX-Large',
  headingXLarge: 'Heading/X-Large',
  headingLarge: 'Heading/Large',
  headingMedium: 'Heading/Medium',
  bodyLarge: 'Body/Large/16',
  bodyMedium: 'Body/Medium/14',
  bodySmall: 'Body/Small/12',
  bodyXSmall: 'Body/X-Small/10'
};

declare module '@mui/material/styles' {
  interface TypographyVariants
    extends Record<DesignSystemTypographyVariant, CSSProperties> {}

  interface TypographyVariantsOptions
    extends Partial<Record<DesignSystemTypographyVariant, CSSProperties>> {}
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides
    extends Record<DesignSystemTypographyVariant, true> {}
}
